const Builder = require('../BuilderBase');
const TextColumn = require('./TextColumn');
const MappedBooleanColumn = require('./MappedBooleanColumn');

module.exports = class EmbeddedListColumn extends Builder {
    constructor(title, properties) {
        super('listColumn_EmbeddedList', title, properties);
    }

    text(title, properties) {
        const textColumn = new TextColumn(title, properties);
        this.addChildBlock(textColumn, 'columns');
        return textColumn;
    }

    mappedBoolean(title, properties) {
        const mappedBooleanColumn = new MappedBooleanColumn(title, properties);
        this.addChildBlock(mappedBooleanColumn, 'columns');
        return mappedBooleanColumn;
    }
};
